import {IArtistJson, IMessage, ISongJson} from '../../server/src/modules/shared-interfaces';
import {EventBus} from '@/EventBus';
import * as artist from '@/api/artists';
import * as songs from '@/api/songs';
import {Song} from "../../server/src/entity/Song";


interface ITarritaStore {
    messages: IMessage[];
    artists: IArtistJson[];
    songs: ISongJson[];
    currentSong: ISongJson | null;
    currentArtist: IArtistJson | null;
    currentFilter: string;
    toolbar: {
        fontSize: number,
        cols: '1' | '2'
    }
    searchingMode: boolean,
}


class Store {
    data: ITarritaStore = {
        messages: [],
        artists: [],
        songs: [],
        currentArtist: null,
        currentSong: null,
        currentFilter: '',
        toolbar: {
            fontSize: 11,
            cols: '1'
        },
        searchingMode: false,
    }

    constructor() {
        EventBus.$on('message.add', (message: IMessage) => {
            this.addMessage(message);
        });
        EventBus.$on('message.remove', (id: string) => {
            this.removeMessage(id)
        });
        this.fetchArtists();
        this.fetchSongs();
    }

    fetchArtists() {
        artist.getAll()
            .then(artist => this.data.artists = artist)
    }

    fetchSongs() {
        songs.getAll()
            .then(songs => this.data.songs = songs)
    }

    fetchCurrentSong(id: number) {
        const fnUpdate = (song : ISongJson) => this.data.currentSong = song;
        songs.getById(id, fnUpdate)
            .then(fnUpdate)
    }

    cleanCurrents() {
        this.data.currentSong = null;
        this.data.currentArtist = null;
    }

    addError(message: string, id: string) {
        const msg: IMessage = {message, id, type: 'error'};
        this.data.messages.push(msg);
    }

    addMessage(message: IMessage) {
        this.removeMessage(message.id);
        this.data.messages.push(message);
    }

    removeMessage(id: string) {
        this.data.messages = this.data.messages.filter(x => x.id !== id);
    }

    search(name: string) {
        this.data.currentFilter = name;
    }

    toggleSearchingMode() {
        this.data.searchingMode = !this.data.searchingMode;
        if (this.data.searchingMode === false) {
            this.search('');
        }
    }

    newSong() {
        this.data.currentSong = <ISongJson>{
            body: '',
            artistId: null,
            title: ''
        };
    }
}


export const store = new Store();